/** Normalize Quill HTML for storage/display (nbsp → regular spaces). */
export const normalizeQuillHtml = (html) =>
  String(html || "")
    .replace(/&nbsp;/gi, " ")
    .replace(/\u00A0/g, " ");

/** Plain-text length excluding empty formatting tags. */
export const quillPlainTextLength = (html) =>
  normalizeQuillHtml(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim().length;
